<template>
    <div class="captcha-container">
        <canvas
            ref="canvasEl"
            :width="width"
            :height="height"
            @click="refreshCaptcha"
            style="cursor: pointer; border: 1px solid #ddd"
        ></canvas>
    </div>
</template>

<script>
export default {
    name: "VerifyCode",
    props: {
        width: {
            type: Number,
            default: 160,
        },
        height: {
            type: Number,
            default: 60,
        },
        minNumber: {
            type: Number,
            default: 10,
        },
        maxNumber: {
            type: Number,
            default: 99,
        },
    },
    data() {
        return {
            correctResult: 0, // 存储正确答案
            displayText: "", // 存储显示的算式文本
        };
    },
    mounted() {
        this.refreshCaptcha();
    },
    methods: {
        // 生成随机数
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },

        // 生成随机颜色
        randomColor(min, max) {
            const r = this.randomNum(min, max);
            const g = this.randomNum(min, max);
            const b = this.randomNum(min, max);
            return `rgb(${r},${g},${b})`;
        },

        // 生成计算题验证码
        generateMathProblem() {
            const num1 = this.randomNum(this.minNumber, this.maxNumber);
            const num2 = this.randomNum(this.minNumber, this.maxNumber);

            // 随机选择加法或减法
            const operators = ["+", "-"];
            const operator = operators[this.randomNum(0, 1)];

            // 计算正确答案
            if (operator === "+") {
                this.correctResult = num1 + num2;
            } else {
                // 确保减法结果不为负数
                this.correctResult =
                    Math.max(num1, num2) - Math.min(num1, num2);
            }

            this.displayText = `${Math.max(num1, num2)} ${operator} ${Math.min(
                num1,
                num2
            )} = ?`;
            return this.displayText;
        },

        // 绘制验证码
        drawCaptcha() {
            const canvas = this.$refs.canvasEl;
            const ctx = canvas.getContext("2d");

            // 清空画布
            ctx.clearRect(0, 0, this.width, this.height);

            // 绘制浅色背景
            ctx.fillStyle = this.randomColor(200, 255);
            ctx.fillRect(0, 0, this.width, this.height);

            // 生成计算题
            const problemText = this.generateMathProblem();

            // 设置文字样式
            ctx.font = "bold 20px Arial";
            ctx.textBaseline = "middle";
            ctx.textAlign = "center";

            // 绘制主要文本（带扭曲效果）
            const textX = this.width / 2;
            const textY = this.height / 2;

            // 添加文字扭曲效果
            for (let i = 0; i < problemText.length; i++) {
                const char = problemText[i];
                const charX = textX - (problemText.length * 8) / 2 + i * 16;

                // 随机旋转角度
                const rotateAngle = (Math.random() - 0.5) * 0.4;
                ctx.save();
                ctx.translate(charX, textY);
                ctx.rotate(rotateAngle);

                // 随机颜色
                ctx.fillStyle = this.randomColor(0, 120);
                ctx.fillText(char, 0, 0);
                ctx.restore();
            }

            // 绘制干扰线
            for (let i = 0; i < 3; i++) {
                ctx.beginPath();
                ctx.moveTo(
                    this.randomNum(0, this.width),
                    this.randomNum(0, this.height)
                );
                ctx.lineTo(
                    this.randomNum(0, this.width),
                    this.randomNum(0, this.height)
                );
                ctx.strokeStyle = this.randomColor(150, 200);
                ctx.lineWidth = 1;
                ctx.stroke();
            }

            // 绘制干扰点
            for (let i = 0; i < 50; i++) {
                ctx.beginPath();
                const x = this.randomNum(0, this.width);
                const y = this.randomNum(0, this.height);
                ctx.arc(x, y, 1, 0, 2 * Math.PI);
                ctx.fillStyle = this.randomColor(0, 255);
                ctx.fill();
            }

            // 向父组件传递正确答案
            this.$emit("code-generated", this.correctResult);
        },

        // 刷新验证码
        refreshCaptcha() {
            this.drawCaptcha();
        },

        // 验证用户输入
        validate(input) {
            return parseInt(input) === this.correctResult;
        },

        // 获取当前验证码信息（用于调试）
        getCaptchaInfo() {
            return {
                problem: this.displayText,
                answer: this.correctResult,
            };
        },
    },
};
</script>
